import { render, staticRenderFns } from "./CBProposalPolicyholder.vue?vue&type=template&id=12418e76"
import script from "./CBProposalPolicyholder.vue?vue&type=script&lang=js"
export * from "./CBProposalPolicyholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports